export default function Pandas_Exercises() {
  return <div>Pandas_Exercises </div>;
}
